export const TEXT_KEYS = {
    EVENT_TITLE: 'content__event-title'
};

export const STYLES = {
    CONTENT: 'sitegen-content-banner',
    DESCRIPTION: 'sitegen-content-banner__description'
};
